import React, { useEffect, useRef, useState } from "react"
import TextInputField from "../textInput"
import classNames from "classnames"
import { useLanguage } from "@languages/index"

interface Props {
  classNames?: any
  count?: number
  descriptions?: any
  fetchedIds?: any
  fetchedDescriptions?: any
  title: string
  min?: number
  max?: number
  defaultValue?: number
  hasAdditionalDescriptions?: boolean
  onClickInfoIcon?: () => void
  onChange?: ({ count, ids, descriptions }) => void
  onInput?: ({ count, ids, descriptions }) => void
  onExceededMaxValue?: (value: number) => void
}

const GuidelineCounterForEditor = ({
  classNames: additionalClassNames,
  count,
  descriptions,
  fetchedIds,
  fetchedDescriptions,
  title,
  min,
  max,
  defaultValue,
  hasAdditionalDescriptions,
  onClickInfoIcon,
  onChange,
  onInput,
  onExceededMaxValue,
  ...rest
}: Props) => {
  const language = useLanguage()
  const languageTexts = { ...language.common, ...language.component.guidelineCounter }

  const decrement = () => {
    if (count <= min) return

    const new_count = count - 1
    var params = {
      count: new_count,
      ids: fetchedIds,
      descriptions: !hasAdditionalDescriptions
        ? []
        : Array.from({ length: new_count }, (_, index) => descriptions[index] || ""),
    }
    if (onChange) onChange(params)
  }

  const increment = () => {
    if (count >= max) {
      if (onExceededMaxValue) {
        onExceededMaxValue(count)
      }
      return
    }

    const new_count = count + 1
    var params = {
      count: new_count,
      // ids: Array.from(
      //   { length: new_count },
      //   (_, index) => (fetchedIds != null && fetchedIds[index]) || null
      // ),
      ids: fetchedIds,
      descriptions: !hasAdditionalDescriptions
        ? []
        : Array.from(
            { length: new_count },
            (_, index) =>
              (descriptions != null && descriptions[index]) ||
              (fetchedDescriptions != null && fetchedDescriptions[index]) ||
              ""
          ),
    }
    if (onChange) onChange(params)
  }

  const updateDescriptions = (index, value) => {
    const temp = [...descriptions]
    temp[index] = value
    if (onChange)
      onChange({
        count,
        ids: fetchedIds,
        descriptions: temp,
      })
  }

  return (
    <div
      className={classNames(["flex", "flex-col", "gap-2"], additionalClassNames ? [...additionalClassNames] : "")}
      {...rest}
    >
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center flex-nowrap">
          <div>{title}</div>
          <img
            className={"w-[14px] h-[14px] ml-2"}
            src={`/assets/icons/ic-help-circle-black.svg`}
            onClick={onClickInfoIcon}
          />
        </div>
        <div className="relative flex items-center max-w-[100px]">
          <button
            type="button"
            className="border border-gray-300 rounded-full w-[24px] h-[24px] focus:ring-gray-100 focus:ring-2 focus:outline-none"
            onClick={decrement}
          >
            <svg
              className="mx-auto"
              width="6"
              height="2"
              viewBox="0 0 6 2"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect y="0.5" width="6" height="1" fill="black" />
            </svg>
          </button>

          <input
            type="text"
            className="w-[30px] border-0 text-black text-center block outline-none"
            value={count}
            required
            readOnly
          />

          <button
            type="button"
            className="border border-gray-300 rounded-full w-[24px] h-[24px] focus:ring-gray-100 focus:ring-2 focus:outline-none text-center"
            onClick={increment}
          >
            <svg
              className="mx-auto"
              width="6"
              height="6"
              viewBox="0 0 6 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect y="2.5" width="6" height="1" fill="black" />
              <rect x="3.5" width="6" height="1" transform="rotate(90 3.5 0)" fill="black" />
            </svg>
          </button>
        </div>
      </div>
      {hasAdditionalDescriptions && (
        <div className="flex flex-col gap-2">
          {descriptions &&
            descriptions.map((val, index) => {
              return (
                <TextInputField
                  key={String(index + 1)}
                  bordered
                  inputStyle={{ fontSize: "14px" }}
                  placeholder={languageTexts.fashion_index_placeholder}
                  value={val}
                  onChangeText={(value) => {
                    updateDescriptions(index, value)
                  }}
                />
              )
            })}
        </div>
      )}
    </div>
  )
}

export default GuidelineCounterForEditor
